import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import FilterUsuarioPerfil from 'views/security/usuarioperfil/filterUsuarioPerfil'; // Importing filter component
import TableUsuarioPerfil from 'views/security/usuarioperfil/tableUsuarioPerfil'; // Importing table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the UsuarioPerfilView.
 * @extends JetView
 */
export default class UsuarioPerfilView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        /**
         * Configuration object for the toolbar.
         * Contains a select dropdown, pager, and export options.
         */
        const toolbar = {
            view: 'toolbar', // Toolbar component
            id: 'toolbar', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS class for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                {
                    view: 'select', // Select dropdown component
                    options: ['10', '20', '50', '100'], // Options for the select dropdown
                    width: 70, // Width of the select dropdown
                    on: {
                        onChange: function () {
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size based on selected value
                            $$('datatable').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager component
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for the pager
                    autosize: false, // Disable autosize
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from configuration
                },
                {
                    view: 'richselect', // Rich select component
                    name: 'Export', // Name of the rich select
                    id: 'Export', // Unique identifier for the rich select
                    width: 120, // Width of the rich select
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Option for exporting to Excel
                        { id: '2', value: 'PDF' }, // Option for exporting to PDF
                    ],
                    on: {
                        onChange: function (value) {
                            if (value == 1) {
                                var table = $$('datatable');
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Usuario Perfil',
                                        TypeReport: 'Excel',
                                    },
                                ]);
                                webix.toExcel(table, {
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Usuario Perfil',
                                    ignore: {
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                });
                            } else {
                                if (value == 2) {
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                                'Usuario Perfil',
                                            TypeReport: 'PDF',
                                        },
                                    ]);
                                    webix.toPDF($$('datatable'), {
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Usuario Perfil',
                                        autowidth: true,
                                        ignore: {
                                            detailTittle: true,
                                            ActionTittle: true,
                                        },
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset the rich select value
                        }.bind(this),
                    },
                },
            ],
        };

        /**
         * Configuration object for the left section of the view.
         * Contains a toolbar, filter, table, and additional toolbar.
         */
        const left = {
            css: 'int-left', // CSS class for styling
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // CSS class for styling based on the theme
                    elements: [
                        { view: 'label', label: _('Usuario Perfil') }, // Label component with text "Usuario Perfil"
                        {
                            type: 'wide', // Type of the component
                            css: 'close-bottom', // CSS class for styling
                            cols: [
                                {
                                    view: 'icon', // Icon component
                                    icon: 'wxi-close', // Close icon
                                    bottom: 20, // Bottom position
                                    right: 35, // Right position
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => this.show('/top/dashboard'), // Click event handler to navigate to the dashboard
                                },
                            ],
                        },
                    ],
                },
                FilterUsuarioPerfil, // Filter component
                TableUsuarioPerfil, // Table component
                toolbar, // Toolbar configuration
            ],
        };

        webix.ui.fullScreen(); // Enable full screen mode

        /**
         * Configuration object for the main view.
         * Contains a form with a responsive layout.
         */
        return {
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Type of the view
            view: 'form', // Form component
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    responsive: 'a5', // Responsive layout
                    type: 'wide', // Wide layout type
                    cols: [
                        left, // Left section configuration
                    ],
                },
            ],
        };
    }
}

// FILE DOCUMENTED
